import PrevisionDescriptionHeader from "./prevision-description-header/PrevisionDescriptionHeader";
import PrevisionDescriptionContent from "./prevision-description-content/PrevisionDescriptionContent";
import CityLocation from "@/components/city-location/CityLocation";
import PrintButton from "@/components/print-button/PrintButton";

import { useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";

import "./style.scss";

export const App = () => {
	const datePlus = new Date(new Date().setHours(23, 59, 59, 59));
	datePlus.setDate(datePlus.getDate() + 4);

	const pathname = window.location.pathname;

	const isMarine = pathname.includes("marine");

	const {
		selectedDailyDate,
		selectedDailyDateMarine,
		forecastData,
		error,
		isLoading,
	} = useSelect((select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
		const store = select(WEATHER_STORE);

		return {
			selectedDailyDate: store.getDateSelectedCityState(),
			selectedDailyDateMarine: store.getMarineDate(),
			...store.getForecastKuwaitState(),
		};
	});

	const isOutOf5Days =
		(isMarine
			? selectedDailyDateMarine.date.getTime()
			: selectedDailyDate.getTime()) > datePlus.getTime();

	return (
		<div className="weather-prevision-description">
			<div className="weather-prevision-title">
				<CityLocation showCity={false} locationName={"Kuwait"} />
				<PrintButton />
			</div>

			<div className="content-prevision">
				<PrevisionDescriptionHeader
					selectedDate={
						isMarine ? selectedDailyDateMarine.date : selectedDailyDate
					}
					isMarine={isMarine}
				/>
				<PrevisionDescriptionContent
					forecastData={isOutOf5Days ? null : forecastData}
					isLoading={isLoading}
					error={error}
					date={isMarine ? selectedDailyDateMarine.date : selectedDailyDate}
				/>
			</div>
		</div>
	);
};

export default App;
